import React, { useState } from 'react';
import './FrequentAsked.css';

const FrequentAsked = ({ title, questions }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="frequent-asked bg-light">
            <h2 className="text-center text-primary mb-4">{title}</h2>
            <div className="accordion" id="faqAccordion">
                {questions.map((question, index) => (
                    <div className="accordion-item" key={index}>
                        <h2 className="accordion-header" id={`heading${index}`}>
                            <button
                                className={`accordion-button ${activeIndex === index ? '' : 'collapsed'}`}
                                type="button"
                                onClick={() => handleToggle(index)}
                                aria-expanded={activeIndex === index}
                                aria-controls={`collapse${index}`}
                            >
                                {question.title}
                            </button>
                        </h2>
                        <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}
                            aria-labelledby={`heading${index}`}
                            data-bs-parent="#faqAccordion"
                        >
                            <div className="accordion-body">
                                {question.answer.split('\n').map((line, i) => (
                                    <p key={i}>
                                        {line.startsWith('-') ? (
                                            <span className="bullet-point">{line.substring(1)}</span>
                                        ) : (
                                            line
                                        )}
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FrequentAsked;